import Vue from "vue";
import {
  Button,
  Checkbox,
  Input,
  InputNumber,
  Textarea,
  Icon,
  Select,
  Tabs,
  Tab,
  Alert,
  message,
  RadioGroup,
  Radio,
  Table,
  Empty,
  Spinner,
  Form,
  FormField,
  Dialog,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Modal,
  DatePicker,
} from "amumu-ui";

const mmComponents = [
  Button,
  Checkbox,
  Input,
  InputNumber,
  Textarea,
  Icon,
  Select,
  Tabs,
  Tab,
  Alert,
  Radio,
  RadioGroup,
  Table,
  Empty,
  Spinner,
  Form,
  FormField,
  Dialog,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Modal,
  DatePicker,
];
mmComponents.forEach(component => {
  Vue.component(component.name, component);
});
Vue.prototype.$message = message;
